import { createSlice } from "@reduxjs/toolkit";

import { languagesAPI } from "../../../api/master";
import { sliceHandler } from "../utils";

const getLanguages = createSlice(
    sliceHandler({
        name: 'getLanguages',
        action: 'getLanguagesSlice',
        success: 'getLanguagesSliceSuccess',
        failure: 'getLanguagesSliceFailure',
        reset: 'getLanguagesSliceReset'
    })
);

const getLanguagesAction: any = getLanguages.actions;
const getLanguagesHandler = () => async (dispatch: any) => {
    try {
        dispatch(getLanguagesAction.getLanguagesSlice());
        const response: any = await languagesAPI();
        dispatch(getLanguagesAction.getLanguagesSliceSuccess(response));
    } catch (e: any) {
        dispatch(getLanguagesAction.getLanguagesSliceFailure(e?.response?.data));
    }
};

export {
    getLanguagesAction,
    getLanguagesHandler,
}
export default getLanguages.reducer;